import React, { useEffect } from "react";
import TransactionsFinancialAccount from "./TransactionsFinancialAccount";
import TransactionTab from "./TransactionTab";
import DedicatedResolutionSpecialistCard from "../RightSideCard/DedicatedResolutionSpecialistCard";
import ErrorBoundary from "../common/ErrorBoundary";
import LogoContainer from "../common/LogoContainer";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
export default function FinancialAccount() {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [routeLoading]);
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="financial-account-page">
                        Transactions
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>
            <TransactionTab selectedTab="2" />
            <div className="row" id="content">
                <div className="col-xs col-no-gutter">
                    <div className="row">
                        <div className="col-xs-12 col-sm-8">
                            <ErrorBoundary componentName="Financial Account Transactions" type="showError" replaceDefaultContent={false} errorMsg="">
                                <TransactionsFinancialAccount />
                            </ErrorBoundary>
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <DedicatedResolutionSpecialistCard />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
